import http from "@/services/http";
import { IUploadFileRes, ICstoreUploadRes } from "@/types/upload";

interface CstorePolicy {
  headerFields: Array<{ key: string; value: any }>;
  uploadUrl: string;
  formFields: Array<{ name: string; value: any }>;
}

// 文件上传
export async function uploadFile(params: FormData, signal: AbortSignal) {
  const res = await http.post<IUploadFileRes>(
    `/api/open/file-upload/upload`,
    params,
    { headers: { "Content-Type": "multipart/form-data" }, signal }
  );
  return res.data;
}

// 获取文件下载链接
export async function getFileDownloadUrl(fileKey: string) {
  const res = await http.get<string>(
    `/api/open/file-upload/download-url?fileKey=${fileKey}`
  );
  return res.data;
}

// 获取cstore上传协议
export async function getUploadPolicy(fileHash: string, suffix: string) {
  const policy = await http.get<CstorePolicy>(`/api/open/file-upload/upload/policy?fileHash=${fileHash}&suffix=${suffix}`);
  return policy.data;
}

// 文件上传
export async function uploadToCstore(url: string, params: FormData, signal: AbortSignal, progressCb: (progress: number) => void) {
  const res = await http.post<ICstoreUploadRes>(
    url,
    params,
    {
      timeout: 1000 * 60 * 30, // 30分钟超时, 防止大文件网速差时上传失败
      headers: { "Content-Type": "multipart/form-data" },
      signal,
      skipAuth: import.meta.env.MODE === 'private',
      onUploadProgress(progressEvent) {
        const { loaded, total } = progressEvent;
        if (total) {
          const progress = Math.round(loaded / total * 100);
          console.log('上传进度：', progress);
          progressCb(progress);
        }
      },
    },
  );
  return res.data;
}

// 私有化文件上传
export function uploadToPrivateCstore(url: string, params: FormData, signal: AbortSignal, progressCb: (progress: number) => void) {
  return http.post(
    url,
    params,
    {
      timeout: 1000 * 60 * 30, // 30分钟超时, 防止大文件网速差时上传失败
      headers: { "Content-Type": "multipart/form-data" },
      signal,
      skipAuth: import.meta.env.MODE === 'private',
      skipResponseValidation: true, // 跳过 response code 验证，某些第三方存储接口返回 200 但无需判断 response
      onUploadProgress(progressEvent) {
        const { loaded, total } = progressEvent;
        if (total) {
          const progress = Math.round(loaded / total * 100);
          console.log('上传进度：', progress);
          progressCb(progress);
        }
      },
    },
  );
}

export async function notifyUploadResult(fileKey: string) {
  console.log('notifyUploadResult fileKey = ', fileKey);
  const host = import.meta.env.VITE_UPLOAD_HOST || location.host;
  console.log('host = ', host);
  const url = `http://${host}/storage/gateway/cstore/api/v3/upload/notifyResult`;
  const res = await http.post<ICstoreUploadRes>(url, {
    keyInfoFields: [{ name: 'fileKey', value: fileKey }]
  }, {
    skipResponseValidation: true, // 跳过 response code 验证，某些第三方存储接口返回 200 但无需判断 response
  });
  return res.data;
}
